import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPrizeImage = () => {
  const get = useTypedApiClient({
    path: '/setting/patron-app/prize-image',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/setting/patron-app/prize-image'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
